import * as React from 'react'
import { LogoWidget } from './LogoWidget'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const LogoWidgetExamples = () => {
  return (
    <div className="LogoWidgetExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <LogoWidget />
      </Provider>
    </div>
  )
}
